import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { queryDataSetPage, getDataMetaBySetIdPage, dataSetSync, dataSetDelete, dataSetEnable, dataMetaDelete } from '@/api/form/formManageApi.js';
export default {
  data: function data() {
    return {
      loading: false,
      childLoading: false,
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      setObj: {
        params: '',
        sxzt: '',
        sjybm: '',
        sjjbm: ''
      },
      metaObj: {
        params: '',
        sjybm: '',
        sjjbm: ''
      },
      expandedRowKeys: [],
      setList: [],
      columns: [{
        title: '数据集ID',
        dataIndex: 'sjjbm',
        align: 'left',
        width: 180
      }, {
        title: '数据集名称',
        dataIndex: 'sjjmc',
        ellipsis: true,
        width: 120
      }, {
        title: '数据集别名',
        dataIndex: 'bm',
        align: 'center',
        ellipsis: true,
        width: 120
      }, {
        title: '状态',
        dataIndex: 'sjzt',
        resizable: true,
        width: 100,
        scopedSlots: {
          customRender: 'sjzt'
        }
      }, {
        title: '状态说明',
        dataIndex: 'ztsm',
        align: 'center',
        ellipsis: true,
        width: 120
      }, {
        title: '创建日期',
        dataIndex: 'cjsj',
        align: 'center',
        width: 150
      }, {
        title: '更新日期',
        dataIndex: 'gxsj',
        align: 'center',
        width: 150
      }, {
        title: '生效状态',
        dataIndex: 'sxzt',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'sxzt'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      metaList: [],
      innerColumns: [{
        title: '序号',
        dataIndex: 'xh',
        resizable: true,
        width: 50
      }, {
        title: '元数据ID',
        dataIndex: 'ysjbm',
        resizable: true,
        ellipsis: true,
        width: 150
      }, {
        title: '元数据名称',
        dataIndex: 'ysjmc',
        resizable: true,
        ellipsis: true,
        width: 150
      }, {
        title: '元数据别名',
        dataIndex: 'bm',
        ellipsis: true,
        resizable: true,
        width: 150
      }, {
        title: '是否主键',
        dataIndex: 'sfzj',
        ellipsis: true,
        resizable: true,
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'sfzj'
        }
      }, {
        title: '允许为空',
        dataIndex: 'sfwk',
        ellipsis: true,
        resizable: true,
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'sfwk'
        }
      }, {
        title: '数据类型',
        dataIndex: 'sjlx',
        ellipsis: true,
        resizable: true,
        width: 120
      }, {
        title: '数据长度',
        dataIndex: 'sjcd',
        ellipsis: true,
        resizable: true,
        width: 80
      }, {
        title: '数据精度',
        dataIndex: 'jdcd',
        ellipsis: true,
        resizable: true,
        width: 80
      }, {
        title: '状态',
        dataIndex: 'sjzt',
        resizable: true,
        width: 100,
        scopedSlots: {
          customRender: 'sjzt'
        }
      }, {
        title: '状态说明',
        dataIndex: 'ztsm',
        ellipsis: true,
        resizable: true,
        width: 150
      }, {
        title: '创建时间',
        dataIndex: 'cjsj',
        resizable: true,
        ellipsis: true,
        width: 150
      }, {
        title: '更新时间',
        dataIndex: 'gxsj',
        resizable: true,
        ellipsis: true,
        width: 150
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      pagination: this.$hdk.page(),
      childPagination: this.$hdk.page()
    };
  },
  methods: {
    loadData: function loadData(sjybm) {
      var setObj = this.setObj,
        metaObj = this.metaObj,
        setFetch = this.setFetch,
        pagination = this.pagination;
      setObj.sjybm = sjybm;
      metaObj.sjybm = sjybm;
      setFetch(pagination);
    },
    setFetch: function setFetch(options) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var pagination, setObj, pager, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              pagination = _this.pagination, setObj = _this.setObj, pager = _.assign({}, pagination, options);
              _this.loading = true;
              if (!pager.setObj) {
                pager.setObj = setObj;
              }
              _context.n = 1;
              return queryDataSetPage(_objectSpread({
                pageNumber: pager.current,
                pageSize: pager.pageSize
              }, pager.setObj));
            case 1:
              res = _context.v;
              _this.setList = res.data.data.records;
              _.assign(pagination, {
                total: res.data.data.total,
                current: pager.current,
                pageSize: pager.pageSize
              });
              _.assign(setObj, pager.setObj);
            case 2:
              _context.p = 2;
              _this.expandedRowKeys = [];
              _this.loading = false;
              return _context.f(2);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0,, 2, 3]]);
      }))();
    },
    metaFetch: function metaFetch(options, sjjbm) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var childPagination, metaObj, pager, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              childPagination = _this2.childPagination, metaObj = _this2.metaObj, pager = _.assign({}, childPagination, options);
              _this2.childLoading = true;
              if (!pager.metaObj) {
                pager.metaObj = metaObj;
              }
              _this2.metaObj.sjjbm = sjjbm;
              _context2.n = 1;
              return getDataMetaBySetIdPage(_objectSpread({
                pageNumber: pager.current,
                pageSize: pager.pageSize
              }, _this2.metaObj));
            case 1:
              res = _context2.v;
              _this2.metaList = res.data.data.records;
              _.assign(childPagination, {
                total: res.data.data.total,
                current: pager.current,
                pageSize: pager.pageSize
              });
              _.assign(metaObj, pager.metaObj);
            case 2:
              _context2.p = 2;
              _this2.childLoading = false;
              return _context2.f(2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0,, 2, 3]]);
      }))();
    },
    onChange: function onChange(page) {
      this.setFetch(page);
    },
    childChange: function childChange(page, row) {
      this.metaFetch(page, row.sjjbm);
    },
    search: function search() {
      // 数据集查询
      this.setFetch(this.pagination);
    },
    reset: function reset() {
      // 数据集重置
      this.$refs.searchFrom.resetFields();
      this.setFetch(this.pagination);
    },
    searchChild: function searchChild(row) {
      // 元数据查询
      this.metaFetch(this.childPagination, row.sjjbm);
    },
    onSetSync: function onSetSync(row) {
      var _this3 = this;
      // 数据集同步
      var $confirm = this.$confirm,
        $message = this.$message,
        metaFetch = this.metaFetch;
      $confirm("确认进行同步吗？", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this3.loading = true;
        dataSetSync({
          sjjbm: row.sjjbm
        }).then(function () {
          $message.success('同步成功！');
          metaFetch(_this3.pagination, row.sjjbm);
        }).finally(function () {
          _this3.loading = false;
        });
      }).catch(function () {});
    },
    onSetDel: function onSetDel(row) {
      var _this4 = this;
      // 数据集删除
      var $confirm = this.$confirm,
        $message = this.$message,
        setFetch = this.setFetch;
      $confirm("删除数据集可能会影响相关业务功能异常，请谨慎操作。", "是否删除当前选择的数据集？", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this4.loading = true;
        dataSetDelete({
          sjjbm: row.sjjbm
        }).then(function () {
          $message.success('删除成功！');
          setFetch(_this4.pagination);
        }).finally(function () {
          _this4.loading = false;
        });
      }).catch(function () {});
    },
    onMetaDel: function onMetaDel(ysjbm, sjjbm) {
      var _this5 = this;
      // 元数据删除
      var $confirm = this.$confirm,
        $message = this.$message,
        metaFetch = this.metaFetch;
      $confirm("删除元数据可能会影响相关业务功能异常，请谨慎操作。", "是否删除当前选择的元数据？", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this5.childLoading = true;
        dataMetaDelete({
          ysjbm: ysjbm
        }).then(function () {
          $message.success('删除成功！');
          metaFetch(_this5.childPagination);
        }).finally(function () {
          _this5.childLoading = false;
        });
      }).catch(function () {});
    },
    statusChangeSet: function statusChangeSet(row) {
      var _this6 = this;
      // 启用/停用表单
      var $confirm = this.$confirm,
        $message = this.$message,
        setFetch = this.setFetch;
      $confirm("\u786E\u8BA4".concat(row.sxzt ? '停用' : '启用', "\u8BE5\u6761\u6570\u636E\u5417?"), "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this6.loading = true;
        dataSetEnable({
          sjjbm: row.sjjbm,
          sxzt: row.sxzt == 0 ? 1 : 0
        }).then(function () {
          setFetch(_this6.pagination);
          row.sxzt = !row.sxzt;
          _this6.loading = false;
        }).finally(function () {
          _this6.loading = false;
        });
      }).catch(function () {});
    },
    expandEvt: function expandEvt(expanded, row) {
      if (!expanded) {
        this.expandedRowKeys = [];
        return;
      }
      this.expandedRowKeys = [row.sjjbm];
      this.metaFetch(this.childPagination, row.sjjbm);
    }
  },
  mounted: function mounted() {}
};